import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import store from '../store'


Yup.addMethod(Yup.string, "valida_patente", function (errorMessage) {
    return this.test(`valida_patente`, errorMessage, function (patente) {
        if (patente && patente.length > 0) {
            //var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i;
            var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}|[a-zA-Z]{2,3}[0-9]{3}|[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}$/i;
            if (regex.test(patente)) {
                return true;
            } else {
                return false;
            }
        }
     
        return true;
  })
})
const fechaSiniestro =(store)=>{
  const estado=(store) => state.encargado_compania
  return estado
}

const validationSchemasEnviarCarta = Yup.object({
      idCompaniaIM:Yup.string().required("La Compañía es obligatoria"),
      idSiniestroIM:Yup.string().required("Siniestro CIA IM es obligatorio"),
      montoRecobro:Yup.string().required("El Monto recobro es obligatorio"),
      //fechaSiniestroIM:Yup.date().required("La Fecha es obligatoria"),
      seguroIM:Yup.string().test("seguro",`Debe elegir "Seguro Confirmado"`,
      (val)=>{if(val==="212003")return true}
        ).required("El seguro es obligatorio"),
      porcConvenio:Yup.number().required("El % Convenio es obligatorio").min(0, "El porciento no puede ser negativo").max(100,"El porciento no puede ser mayor a 100"),
      observaciones:Yup.string().test(
      "len",
      "No puede exeder 255 caracteres..",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 0 && val.length <= 255);
      }
    )/*,
      patenteIM:Yup.string().test(
        "len",
        "La Patente no es válida",
        (val) => {
          if (val === undefined) {
            return true;
          }
          return val.length === 0 || (val.length >= 2 && val.length <= 7);
        }
      ).required("La Patente es obligatoria").valida_patente("La Patente no es válida"),*/
   

})
export default validationSchemasEnviarCarta;